/**
 * @desc 用户模块
 */

const agencyHome = (r) =>
  require.ensure(
    [],
    () => r(require('../views/user/AgencyHome.vue')),
    'agencyHome'
  )
const centerManageLogin = (r) =>
  require.ensure(
    [],
    () => r(require('../views/user/CenterManageLogin.vue')),
    'centerManageLogin'
  )
const login = (r) =>
  require.ensure([], () => r(require('../views/user/Login.vue')), 'login')
const userCenter = (r) =>
  require.ensure(
    [],
    () => r(require('../views/user/UserCenter.vue')),
    'userCenter'
  )
const schoolInfo = (r) =>
  require.ensure(
    [],
    () => r(require('../views/user/schoolInfo.vue')),
    'schoolInfo'
  )
const institutionRegister = (r) =>
  require.ensure(
    [],
    () => r(require('../views/user/InstitutionRegister')),
    'institutionRegister'
  )
const home = (r) =>
  require.ensure([], () => r(require('../views/user/Home.vue')), 'home')

const portal = (r) =>
  require.ensure([], () => r(require('../views/user/Portal.vue')), 'portal')

const gateway = (r) =>
  require.ensure(
    [],
    () => r(require('../views/gateway/gateway.vue')),
    'gateway'
  )

//初始化页面，非登录状态可使用
const teacherinformation = (r) =>
  require.ensure(
    [],
    () => r(require('../views/teacher/TeacherInformation.vue')),
    'teacherinformation'
  )

const teacherReview = (r) =>
  require.ensure(
    [],
    () => r(require('../views/teacher/TeacherReview.vue')),
    'teacherReview'
  )

const teacherReviewChange = (r) =>
  require.ensure(
    [],
    () => r(require('../views/teacher/TeacherReviewChange.vue')),
    'teacherReviewChange'
  )
const teacherFlexibleReview = (r) =>
  require.ensure(
    [],
    () => r(require('../views/teacher/teacherFlexibleReview.vue')),
    'teacherFlexibleReview'
  )
const index = (r) =>
  require.ensure([], () => r(require('../views/gateway/index.vue')), 'index')
const course = (r) =>
  require.ensure([], () => r(require('../views/gateway/course.vue')), 'course')
const parent = (r) =>
  require.ensure([], () => r(require('../views/gateway/parent.vue')), 'parent')
const more = (r) =>
  require.ensure([], () => r(require('../views/gateway/more.vue')), 'more')
const courseDetail = (r) =>
  require.ensure(
    [],
    () => r(require('../views/gateway/courseDetail.vue')),
    'courseDetail'
  )
const NOIE = (r) =>
  require.ensure([], () => r(require('../views/user/NOIE.vue')), 'NOIE')

const newsDetail = (r) =>
  require.ensure(
    [],
    () => r(require('../views/gateway/newsDetail.vue')),
    'newsDetail'
  )
// 导出群二维码
const exportQrcode = r =>
  require.ensure([], () => r(require('../views/education/exportQrcode.vue')), 'exportQrcode')

export default [
  //代理登录后首页
  {
    name: 'agencyHome',
    path: '/agencyHome',
    component: agencyHome,
    meta: {
      title: '代理登录后首页',
    },
  },
  //登录页面
  {
    name: 'login',
    path: '/login',
    component: login,
    meta: {
      title: '登录',
    },
  },
  //中心校登录页面
  {
    name: 'centerManageLogin',
    path: '/centerManageLogin',
    component: centerManageLogin,
    meta: {
      title: '中心校登录',
    },
  },
  //个人中心
  {
    name: 'userCenter',
    path: '/userCenter',
    component: userCenter,
    meta: {
      title: '个人中心',
    },
  },
  //学校信息
  {
    name: 'schoolInfo',
    path: '/schoolInfo',
    component: schoolInfo,
    meta: {
      title: '学校信息',
    },
  },
  //课程方注册
  {
    name: 'institutionRegister',
    path: '/institutionRegister',
    component: institutionRegister,
    meta: {
      title: '课程方注册',
    },
  },
  //首页
  {
    name: 'home',
    path: '/home',
    component: home,
    meta: {
      title: '首页',
    },
  },
  {
    name: 'portal',
    path: '/portal',
    component: portal,
    meta: {
      title: '首页',
    },
  },
  {
    name: 'teacherinformation',
    path: '/teacherinformation',
    component: teacherinformation,
    meta: {
      title: '完善信息',
    },
  },
  {
    name: 'teacherReview',
    path: '/teacherReview',
    component: teacherReview,
    meta: {
      title: '老师审核结果',
    },
  },
  {
    name: 'teacherReviewChange',
    path: '/teacherReviewChange',
    component: teacherReviewChange,
    meta: {
      title: '老师信息提交',
    },
  },

  {
    name: 'teacherFlexibleReview',
    path: '/teacherFlexibleReview',
    component: teacherFlexibleReview,
    meta: {
      title: '灵活老师审核',
    },
  },
  {
    name: 'exportQrcode',
    path: '/class/exportQrcode/:id',
    component: exportQrcode,
    meta: { title: '导出班级二维码' },
  },
  {
    name: 'school',
    path: '/school',
    component: gateway,
    meta: {
      title: '一校一案',
    },
    children: [
      {
        name: 'schoolPortal', //warning gateway路由重复
        path: '/school/portal',
        component: index,
        meta: {
          title: '首页',
          showfater: false,
        },
      },
      {
        name: 'course',
        path: '/school/course',
        component: course,
        meta: {
          title: '课程',
          showfater: false,
        },
      },
      {
        name: 'newsDetail',
        path: '/school/newsDetail',
        component: newsDetail,
        meta: { title: '通知与公告' },
      },
      {
        name: 'parent',
        path: '/school/parent',
        component: parent,
        meta: {
          title: '家长端',
          showfater: false,
        },
      },
      {
        name: 'more',
        path: '/school/more',
        component: more,
        meta: {
          title: '更多应用',
          showfater: false,
        },
      },
      {
        name: 'courseDetail',
        path: '/school/courseDetail',
        component: courseDetail,
        meta: {
          title: '课程详情',
          showfater: false,
        },
      },
    ],
  },
  {
    name: 'NOIE',
    path: '/NOIE',
    component: NOIE,
  },
]